import { Icon, IconProps } from "@chakra-ui/react";

function CartIcon(props: IconProps) {
	return (
		<Icon
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				opacity="0.12"
				d="M12.0906 9.83333H3.16669L2.79169 3.83333H14.0708C14.277 3.83333 14.3802 3.83333 14.4554 3.87485C14.5214 3.91131 14.5731 3.9691 14.6021 4.03877C14.635 4.1181 14.6237 4.22058 14.6009 4.42556L14.2109 7.93558C14.1363 8.60666 14.099 8.94221 13.9442 9.19543C13.8079 9.41849 13.6089 9.59655 13.3722 9.70744C13.1034 9.83333 12.7658 9.83333 12.0906 9.83333Z"
				fill="currentColor"
			/>
			<path
				d="M3.33341 9.83333H12.0906C12.7658 9.83333 13.1034 9.83333 13.3721 9.70744C13.6089 9.59655 13.8078 9.41849 13.9442 9.19543C14.099 8.94221 14.1363 8.60666 14.2108 7.93558L14.6008 4.42556C14.6236 4.22058 14.635 4.1181 14.602 4.03877C14.5731 3.9691 14.5214 3.91131 14.4553 3.87485C14.3801 3.83333 14.277 3.83333 14.0708 3.83333H3.00007M1.33331 1.83333H2.16561C2.34202 1.83333 2.43023 1.83333 2.49924 1.86688C2.55999 1.89641 2.61034 1.94371 2.6436 2.0025C2.68139 2.06929 2.6869 2.15732 2.6979 2.33339L3.30206 11.9999C3.31306 12.176 3.31857 12.264 3.35635 12.3308C3.38962 12.3896 3.43997 12.4369 3.50072 12.4664C3.56973 12.5 3.65794 12.5 3.83435 12.5H12.6666M4.99998 14.8333H5.00665M11 14.8333H11.0066M5.33331 14.8333C5.33331 15.0174 5.18407 15.1667 4.99998 15.1667C4.81588 15.1667 4.66665 15.0174 4.66665 14.8333C4.66665 14.6492 4.81588 14.5 4.99998 14.5C5.18407 14.5 5.33331 14.6492 5.33331 14.8333ZM11.3333 14.8333C11.3333 15.0174 11.1841 15.1667 11 15.1667C10.8159 15.1667 10.6666 15.0174 10.6666 14.8333C10.6666 14.6492 10.8159 14.5 11 14.5C11.1841 14.5 11.3333 14.6492 11.3333 14.8333Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
}

export default CartIcon;
